import script from "./RegistrationTiers.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationTiers.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationTiers.vue?vue&type=style&index=0&id=2891d3a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2891d3a4"]])

export default __exports__